// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".box[data-v-ce8d0a82] {\n  display: flex;\n}\n.title[data-v-ce8d0a82] {\n  font-size: 16px;\n  font-weight: bold;\n  margin-right: 40px;\n}\n.text[data-v-ce8d0a82] {\n  font-size: 16px;\n}\n", ""]);
// Exports
module.exports = exports;
